import Route from '@ember/routing/route';
import { set } from '@ember/object';
import { service } from '@ember/service';

export default Route.extend({
  navbarSettings: service(),

  beforeModel() {
    set(this, 'navbarSettings.title', 'Import from Karani');
  },

  model() {
    return {
      selectedFile: null,
      includePledges: true,
      includeTasks: true,
    };
  },
});
